import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
export function Title() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Dialog.Title className={css({
      flex: "[1]",
      m: "[0]",
      minHeight: "[32px]",
      textStyle: "text.large",
      fontSize: "[18px]",
      fontWeight: "bold",
      lineHeight: "[1.5]",
      color: "neutral.darkest"
    })}>What kind of credit card are you looking for?</Dialog.Title>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}